import { Gender } from "../global/types"

enum AgeBracket {
  LESS_THAN_TWENTY_YEARS = "Less than 20 Years",
  TWENTY_TO_TWENTY_FIVE_YEARS = "20-25 Years",
  TWENTY_FIVE_TO_THIRTY_YEARS = "25-30 Years",
  THIRTY_TO_THIRTY_FIVE_YEARS = "30-35 Years",
  THIRTY_FIVE_TO_FOURTY_YEARS = "35-40 Years",
  FOURTY_TO_FOURTY_FIVE_YEARS = "40-45 Years",
  MORE_THAN_FOURTY_FIVE_YEARS = "More than 45 Years",
}

export enum MaritalStatusEnum {
  UNMARRIED = "unmarried",
  MARRIED = "married",
  DIVORCED = "divorced",
  WIDOWED = "widowed",
}
enum QualificationLevel {
  UNDER_GRADUATE = "under_graduate",
  GRADUATE = "graduate",
  PG = "pg",
  DIPLOMA = "diploma",
  OTHER = "other",
}
export enum QualificationType {
  SUBJECT_QUALIFICATION = "subject_qualification",
  TEACHING_QUALIFICATION = "teaching_qualification",
}
export enum QualificationFormat {
  REGULAR = "regular",
  DISTANCE = "distance",
}

export type LeadQualification = {
  id: number
  level: QualificationLevel | null
  qualificationType: QualificationType | null
  qualificationFormat: QualificationFormat | null
  name: string
  institutionName: string | null
  subjectId: string | null
  startDate: string | null
  endDate: string | null
  userLead: number
}

export type LeadProfile = {
  id: number
  userLead: {
    email: string
    fullName: string
    phoneNumber: string
    user: string | null
  }
  gender: Gender | null
  dateOfBirth: string | null
  ageBracket: AgeBracket | null
  maritalStatus: MaritalStatusEnum | null
  hasNationallyAccreditedTeachingQualification: boolean
  hasTeachingQualification: boolean
  hasSubjectQualification: boolean
  yearsOfExperience: number | null
  curriculumsTaught: string[] | null
  currentSalary: number | null
  currentSalaryCurrency: string | null
  desiredOutcome: string | null
  desiredCountries: string[] | null
  desiredSalary: number | null
  desiredSalaryCurrency: string | null
  primaryGoal: string | null
  secondaryGoal: string | null
  country: string | null
  state: string | null
  city: string | null
  qualifications: LeadQualification[]
}

export const qualificationLevelChoices: {
  label: string
  value: string
}[] = [
  { label: "Under Graduate", value: QualificationLevel.UNDER_GRADUATE },
  { label: "Graduate", value: QualificationLevel.GRADUATE },
  { label: "Post Graduate", value: QualificationLevel.PG },
  { label: "Diploma", value: QualificationLevel.DIPLOMA },
  { label: "Other", value: QualificationLevel.OTHER },
]

export const qualificationTypeChoices: {
  label: string
  value: string
}[] = [
  {
    label: "Teaching Qualification",
    value: QualificationType.TEACHING_QUALIFICATION,
  },
  {
    label: "Subject Qualification",
    value: QualificationType.SUBJECT_QUALIFICATION,
  },
]

export const qualificationFormatChoices: {
  label: string
  value: string
}[] = [
  { label: "Regular", value: QualificationFormat.REGULAR },
  { label: "Distance", value: QualificationFormat.DISTANCE },
]
